import React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormularioCuentas from "components/cuentas/FormularioCuentas";
import Navbar from "components/generales/Navbar";
import axios from "axios";
import Spinner from "../../components/generales/Spinner";
import "components/cuentas/StylesCuentas.css";
const EditarCuenta = () => {
  const [cuenta, setCuenta] = useState({});
  const [cargando, setCargando] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const obtenerCuentaAPI = async () => {
    try {
      const token = localStorage.getItem("token");
      const url = `https://mymoney5.herokuapp.com/cuentas/${id}`;
      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (status !== 200) {
        setCargando(false);
        return;
      }
      setCuenta(data);
    } catch (error) {}
    setCargando(false);
  };

  useEffect(() => {
    obtenerCuentaAPI();
  }, []);
  return (
    <>
      <Navbar />
      <section>
        <div className="imagenContenedor imagenCuentas"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>Editar Cuentas</h2>
            {!cargando ? <FormularioCuentas cuenta={cuenta} /> : <Spinner />}
          </div>
        </div>
      </section>
    </>
  );
};

export default EditarCuenta;
